<template>
  <figure
    class="c-picture picture"
    :class="{
      'picture--fit': !isImg,
    }"
    :data-animation="lazy && isAnimated ? 'picture' : false"
  >
    <div class="picture__mask">
      <img
        class="picture__img"
        :data-src="lazy ? data.src : null"
        :src="!lazy ? data.src : null"
        :alt="data.alt"
      >
    </div>
  </figure>
</template>

<script>
export default {
  name: 'AppPicture',
  props: {
    data: {
      type: Object,
      required: false,
      default() {
        return {
          src: 'https://picsum.photos/1440/1080',
          alt: 'placeholder',
        };
      },
    },
    lazy: {
      type: Boolean,
      required: false,
      default: true,
    },
    isAnimated: {
      type: Boolean,
      required: false,
      default: true,
    },
    isImg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    loadPicture() {
      const img = this.$el.querySelector('.picture__img');
      const { src } = this.data;

      img.decoding = 'sync';
      img.src = src;
      img.removeAttribute('data-src');

      return img.decode();
    },
  },
};
</script>

<style lang="scss" scoped>
.picture {
  position: relative;
  background-color: var(--color-bg);

  &__img {
    display: block;

    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;

    mix-blend-mode: overlay;

    -webkit-user-drag: none;
    -moz-user-drag: none;
    -ms-user-drag: none;
  }

  &__mask {
    overflow: hidden;
  }

  &.picture--fit {
    .picture__mask,
    .picture__img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .picture__img {
      object-fit: cover;
      mix-blend-mode: overlay;
    }
  }
}
</style>
